<app-dialog-heading [heading]="'Broker Permissions'"></app-dialog-heading>

<div class="dialog-content">
  <form [formGroup]="form">
    <div class="flex items-center justify-between py1"
         *ngFor="let feature of data.availableFeatures">
      <div class="flex-auto m-r-10">
        <app-element-slide-toggle
          [label]="feature.name"
          [formControlName]="feature.name"
          (valueChanged)="toggleFeature(feature.name, $event)">
        </app-element-slide-toggle>
      </div>
    </div>
  </form>

  <div mat-dialog-actions class="dialog-button-container mt3">
    <div class="flex justify-center">
      <button class="dialog-button mr2" mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
      <button class="dialog-button"
              mat-raised-button
              color="primary"
              [disabled]="!this.data?.canManageFeatures"
              (click)="onSave()">Okay</button>
    </div>
  </div>
</div>
